import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { AutosuggestModule } from './autosuggest/autosuggest.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VervotechCheckboxComponent } from './vervotech-checkbox/vervotech-checkbox.component';
import { FilterListComponent } from './filter-list/filter-list.component';
import { DealComponent } from './deal/deal.component';
import { TravellerCountPickerModule } from './traveller-count-picker/traveller-count-picker.module';
import { CalendarModule } from './calendar/calendar.module';
import { RatingsComponent } from './ratings/ratings.component';
import { RangeSliderModule } from './range-slider/range-slider.module';
import { ChipsComponent } from './chips/chips.component';
import { EmailSubscribeComponent } from './email-subscribe/email-subscribe.component';
import { TextHighlighterPipe } from './pipes/text-highlighter.pipe';
import { CustomCurrencyPipe } from './pipes/currency/currency.pipe';
import { AutosuggestPopupModule } from './autosuggest-popup/autosuggest-popup.module';
import { PopOverComponent } from './pop-over/pop-over.component';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ModalComponent } from './modal/modal.component';
import { ZsIconComponent } from './zs-icon/zs-icon.component';
import { ImageGalleryComponent } from './image-gallery/image-gallery.component';
import { ImageViewerNewComponent } from './image-viewer/image-viewer.component';
import { TruncatePipe } from './pipes/truncate/truncate.pipe';


@NgModule({
  imports: [
    CommonModule,
    AutosuggestModule,
    OverlayModule,
    PortalModule,
    FormsModule,   
    ReactiveFormsModule,
    TravellerCountPickerModule,
    CalendarModule,
    RangeSliderModule,
    AutosuggestPopupModule,
    MatCheckboxModule,
    MatInputModule

  ],
  declarations: [
    VervotechCheckboxComponent,
    FilterListComponent,
    DealComponent,
    RatingsComponent,
    ChipsComponent,
    EmailSubscribeComponent,
    TextHighlighterPipe,
    CustomCurrencyPipe,
    PopOverComponent,
    ModalComponent,
    ZsIconComponent,
    TruncatePipe,
    ImageGalleryComponent,
    ImageViewerNewComponent
  ],
  exports: [
    AutosuggestModule,
    AutosuggestPopupModule,
    VervotechCheckboxComponent,
    FilterListComponent,
    DealComponent,
    TravellerCountPickerModule,
    CalendarModule,
    RatingsComponent,
    RangeSliderModule,
    ChipsComponent,
    EmailSubscribeComponent,
    TextHighlighterPipe,
    CustomCurrencyPipe,
    PopOverComponent,
    ZsIconComponent,
    TruncatePipe,
    ImageGalleryComponent,
    ImageViewerNewComponent
  ],
  providers: [CurrencyPipe, CustomCurrencyPipe, TruncatePipe]
})
export class SharedComponentsModule { }
